import { Injectable } from '@angular/core';

type BeaconFn = (method: string, options?: unknown, data?: unknown) => void;

@Injectable({
  providedIn: 'root'
})
export class BeaconService {
  // Style applied on pages that should show the floating launcher.
  // Switch to 'icon' if the HelpScout dashboard default is icon-only.
  private static readonly VISIBLE_STYLE = 'iconAndText';
  private static readonly HIDDEN_STYLE = 'manual';

  private get beacon(): BeaconFn | undefined {
    const candidate = (window as any).Beacon;
    return typeof candidate === 'function' ? (candidate as BeaconFn) : undefined;
  }

  public setLauncherVisible(visible: boolean): void {
    const beacon = this.beacon;
    if (!beacon) {
      return;
    }

    const style = visible
      ? BeaconService.VISIBLE_STYLE
      : BeaconService.HIDDEN_STYLE;
    beacon('config', { display: { style } });
  }

  public open(): void {
    const beacon = this.beacon;
    if (!beacon) {
      return;
    }

    beacon('open');
  }
}
